import { NotificationSubscription, OrderStatus, PENDING_SCHEDULING_STATUSES } from '@models';
import { useStore } from '@stores';
import { useEffect } from 'react';

declare const abp: any;

export const useOrderNotification = () => {
  const { orderStore, requestStore } = useStore();
  const {
    addUnassignedServiceOrder,
    removeCalendarOrder,
    removeUnassignedServiceOrder,
    addOrUpdateCalendarOrder,
    updateOrdersStatus,
  } = orderStore;

  const { addRequest, filterRequestSidePanel } = requestStore;

  useEffect(() => {
    abp.event.on('abp.notifications.received', (userNotification: any) => {
      const notificationName = userNotification.notification.notificationName;
      const result = userNotification.notification.data.properties;

      switch (notificationName) {
        case NotificationSubscription.RequestCreated:
          addRequest(result);
          break;
        case NotificationSubscription.OrderCreated:
          if (
            result.status !== OrderStatus.Approval &&
            result.status !== OrderStatus.Approved
          ) {
            // Scheduled means dated, as the API's calendar/unassigned split does: a job can be on
            // a day before it has a technician.
            if (result.startAt) addOrUpdateCalendarOrder(result);
            else addUnassignedServiceOrder(result);
          }
          filterRequestSidePanel(result.requestId);
          break;
        case NotificationSubscription.OrderUpdated:
          // Routed by date, like OrderCreated. An update to a job still waiting in the side panel
          // (title, status) used to be pushed into the calendar map with no start - FullCalendar
          // dropped it with a warning - and taken out of the panel until the next reload.
          if (result.startAt) {
            addOrUpdateCalendarOrder(result);
            removeUnassignedServiceOrder(result.id);
          } else {
            removeCalendarOrder(result.id);
            if (PENDING_SCHEDULING_STATUSES.includes(result.status)) addUnassignedServiceOrder(result);
            else removeUnassignedServiceOrder(result.id);
          }
          break;
        case NotificationSubscription.OrderDeleted:
          removeCalendarOrder(result.id);
          removeUnassignedServiceOrder(result.id);
          break;
        case NotificationSubscription.OrderUnassigned:
          removeCalendarOrder(result.id);
          addUnassignedServiceOrder(result);
          break;
        case NotificationSubscription.OrdersStatusUpdate:
          updateOrdersStatus(result.orders, result.status);
          break;
        default:
          break;
      }
    });
  }, []);
};
